import { use, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Modal } from "bootstrap";
import { LoginContext } from "./LoginContext";
import { FaEye, FaEyeSlash } from "react-icons/fa";
// import alphalogo from "../assets/logo/alphalogo.png";
// import dhcgreportsLogo from "../assets/logo/dhcgreportsLogo.png"
// import dhcgreportsHeader from "../assets/headers/dhcgreportsHeader.png"
// import dhcgreportsFooter from "../assets/footers/dhcgreportsFooter.svg"
// import reportsAlphalabsqatarLogo from "../assets/logo/reportsAlphalabsqatarLogo.png"
// import reportsAlphalabsqatarHeader from "../assets/headers/reportsAlphalabsqatarHeader.svg"
// import reportsAlphalabsqatarFooter from "../assets/footers/reportsAlphalabsqatarFooter.png"
// import wiseMedicalCenterLogo from "../assets/logo/wiseMedicalCenterLogo.png"
// import wiseMedicalCenterHeader from "../assets/headers/wiseMedicalCenterHeader.png"
// import { WiseMedicalCenterFooter } from "../assets/footers/wiseMedicalCenterFooter";
import { siteConfig, defaultTenant } from "../assets/SiteConfig";


export default function LoginPage() {
 const {login, userName, setUserName, userPassword, setUserPassword, error, setError, handleLogin} = useContext(LoginContext);
 const [showPassword, setShowPassword] = useState(false);

  const hostname = window.location.hostname;  
  const siteConfigData = siteConfig[hostname] || defaultTenant;
  
  // console.log(hostname,"hostname");
  // const logoMap = {
  //   "dhcgreports.com" : dhcgreportsLogo,
  //   "reports.alphalabsqatar.com" : reportsAlphalabsqatarLogo,
  //   "localhost" : wiseMedicalCenterLogo,
  // };
  // // const defaultLogo = logo;
  // const headerMap = {
  //   "dhcgreports.com" : dhcgreportsHeader,
  //   "reports.alphalabsqatar.com" : reportsAlphalabsqatarHeader,
  //   "localhost" : wiseMedicalCenterHeader,
  // }
  // const footerMap = {
  //   "dhcgreports.com": dhcgreportsFooter,
  //   "reports.alphalabsqatar.com": reportsAlphalabsqatarFooter,
  //   // "localhost": <WiseMedicalCenterFooter />,
  // };

// const companyLogo = logoMap[hostname];
// const companyHeader = headerMap[hostname];
// const companyFooter = footerMap[hostname];

return (
  <>
  <div className="login-container">  
    <div className="company-header">
      {/* {companyHeader && <img src={companyHeader} alt="" />} */}
      {siteConfigData.header && <img src={siteConfigData.header} alt="header" />}
    </div>
    <div className="login-wrapper">
      <form className="login-box" onSubmit={handleLogin}>
        <div className="company-logo">
          {/* {companyLogo && <img src={companyLogo} alt="logo" />} */}
          {siteConfigData.logo && <img src={siteConfigData.logo} alt="logo" />}
        </div>
        <h3 className="form-label mb-3 mt-3" style={{color: "#00ABEF"}}>Login</h3>
          <div className="col mb-3">
            <label htmlFor="username" className="form-label">Username</label>
            <input
              type="text"
              className="form-control ps-1 input-field"
              id="username"
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
              autoComplete="off"
              required
            />
          </div>
          <div className="col mb-2 position-relative">
            <label htmlFor="password" className="form-label">Password</label>
            <input
              type={showPassword ? "text" : "password"}
              className="form-control ps-1  input-field"
              id="password"
              value={userPassword}
              onChange={(e) => setUserPassword(e.target.value)}
              autoComplete="off"
              required
            />
            <span className="toggle-eye" onClick={() => setShowPassword(!showPassword)}>{showPassword ? <FaEyeSlash /> : <FaEye />}</span>
          </div>
        <div className="row">
          <div className="col d-flex justify-content-end mt-2">
            <button type="submit" className="btn " style={{backgroundColor: '#00ABEF', color: "white",width:"87px"}}>Login</button>
          </div>
        </div>  
        {error && <p style={{textAlign: "center"}} className="text-danger mt-3 text-center">{error}</p>}
      </form>
      </div>
    <div className="company-footer">
      {/* {companyFooter && <img src={companyFooter} alt="" />} */}
      {siteConfigData.footerType === "IMAGE" && (
        <img src={siteConfigData.footer} alt="footer" />
      )}

      {siteConfigData.footerType === "COMPONENT" && siteConfigData.footer && (
        <siteConfigData.footer />
      )}
    </div>
  </div>
  </>
);
}
